import React, { type ReactNode } from 'react'
import { useAuthStore } from '@/stores/authStore'

interface PermissionElementProps {
    children: ReactNode
    requiredPermission?: string | string[]
    fallback?: ReactNode
    showUnauthorizedMessage?: boolean
}

export const PermissionElement: React.FC<PermissionElementProps> = ({
    children,
    requiredPermission,
    fallback = null,
    showUnauthorizedMessage = false,
}) => {
    const user = useAuthStore(state => state.user)
    const isAuthenticated = useAuthStore(state => state.isAuthenticated)

    // No autenticado → no mostrar contenido
    if (!isAuthenticated) {
        return fallback
    }

    // Sin permiso específico → mostrar contenido
    if (!requiredPermission) {
        return <>{children}</>
    }

    // Extraer permisos del usuario
    const userPermissions = user?.permissions ?? []

    const hasPermission = () => {
        if (Array.isArray(requiredPermission)) {
            // necesita TODOS los permisos
            return requiredPermission.every((perm) =>
                userPermissions.includes(perm)
            )
        }
        // necesita UNO
        return userPermissions.includes(requiredPermission)
    }

    if (hasPermission()) {
        return <>{children}</>
    }

    if (showUnauthorizedMessage) {
        console.error('No tienes permiso para acceder a este contenido')
    }

    return <>{fallback}</>
}